import moment from "moment";
import { imageURL } from "../redux/Api/apikit";

let timerId = null;

export let setModal = null;

export const setModalFun = (fun) => {
  setModal = fun;
};

let accessArray = localStorage.getItem("accessArray");
accessArray = JSON.parse(accessArray);

export const debounce = (callback = () => {}, delay = 300) => {
  let value = false;
  if (timerId) {
    clearTimeout(timerId);
  }
  timerId = setTimeout(() => {
    value = callback();
  }, delay);
  return value;
};

export const haveAccess = (text) => {
  console.log(accessArray);
};

export const getFileType = (mimeType) => {
  switch (mimeType) {
    case "text/csv":
      return "csv";
    case "application/vnd.ms-excel":
      return "xlsx";
    default:
      return "unknown"; // or handle other file types if needed
  }
};
export function capitalizeFirstLetters(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function formatDateRange(startStr, endStr) {
  const start = moment(startStr);
  const end = moment(endStr);

  if (start.isSame(end, "day")) {
    return start.format("MMM D, YYYY");
  }

  if (start.isSame(end, "month") && start.isSame(end, "year")) {
    return `${start.format("MMM D")}–${end.format("D, YYYY")}`;
  }

  if (start.isSame(end, "year")) {
    return `${start.format("MMM D")} – ${end.format("MMM D, YYYY")}`;
  }

  return `${start.format("MMM D, YYYY")} – ${end.format("MMM D, YYYY")}`;
}

export const renderPostContent = (record) => {
  const { postType, text, file } = record;

  switch (postType.trim()) {
    case "textOnly":
      return <span>{text}</span>;

    case "textWithGIF":
      return (
        <div className="post-content">
          <p>{text}</p>
          {file && (
            <img src={imageURL + file} alt="gif" style={{ maxWidth: "50px" }} />
          )}
        </div>
      );

    case "imageWithText":
      return (
        <div className="post-content">
          <p>{text}</p>
          {file && (
            <img
              src={imageURL + file}
              alt="post"
              style={{ maxWidth: "50px" }}
            />
          )}
        </div>
      );

    case "videoWithText":
      return (
        <div className="post-content">
          <p>{text}</p>
          {file && (
            <video width="100" controls>
              <source src={imageURL + file} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      );

    default:
      return <span>{text || "N/A"}</span>;
  }
};